export const eFakturaTrackingIDs = {
    shareEFaktura: {
        id: 'dagligbank-share-efaktura',
    },
    deleteSharedEFaktura: {
        id: 'dagligbank-delete-share-efaktura',
    },
    deleteReceivedEFaktura: {
        id: 'dagligbank-delete-received-efaktura',
    },
    updateSharedEFaktura: {
        id: 'dagligbank-update-share-efaktura',
    },
    batchEFaktura: {
        id: 'dagligbank-batch-efaktura',
    },
    togglePushNotificationEfaktura: {
        id: 'dagligbank-toggle-push-notification-efaktura',
    },
    toggleEmailNotificationEfaktura: {
        id: 'dagligbank-toggle-email-notification-efaktura',
    },
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZUZha3R1cmEuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvdXRpbHMvZ3RtL3RyYWNrSURzL2VGYWt0dXJhLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE1BQU0sQ0FBQyxNQUFNLG1CQUFtQixHQUFHO0lBQy9CLGFBQWEsRUFBRTtRQUNYLEVBQUUsRUFBRSwyQkFBMkI7S0FDbEM7SUFDRCxvQkFBb0IsRUFBRTtRQUNsQixFQUFFLEVBQUUsa0NBQWtDO0tBQ3pDO0lBQ0Qsc0JBQXNCLEVBQUU7UUFDcEIsRUFBRSxFQUFFLHFDQUFxQztLQUM1QztJQUNELG9CQUFvQixFQUFFO1FBQ2xCLEVBQUUsRUFBRSxrQ0FBa0M7S0FDekM7SUFDRCxhQUFhLEVBQUU7UUFDWCxFQUFFLEVBQUUsMkJBQTJCO0tBQ2xDO0lBQ0QsOEJBQThCLEVBQUU7UUFDNUIsRUFBRSxFQUFFLDhDQUE4QztLQUNyRDtJQUNELCtCQUErQixFQUFFO1FBQzdCLEVBQUUsRUFBRSwrQ0FBK0M7S0FDdEQ7Q0FDSixDQUFDIn0=